import React, { useState } from "react";
import { Paper } from "@mui/material";
import Navbar from "../components/common/navbar";
import Footer from "../components/common/footer";
import FormDialog from "../components/modal/modal";
import RaggingForm from "../components/ragging/form";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const Ragging = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  return (
    <>
      <Navbar />
      <div className="my-0">
        <img src="./assets/banner/ragging.jpg" className="w-100" alt="anti ragging page" />
        <div className="my-0 p-0">
          <Paper elevation={3}>
            <div className="p-5">
              <div className="text-center">{/* <h2> Anti Ragging</h2> */}</div>
              <div className="font-emoji">
                <div className="row">
                  <p className="text-center">
                    At Purbanchal Educational Welfare Society (PEWS) Group of
                    Institutions, we are dedicated to fostering an atmosphere
                    that is both secure and courteous for every individual
                    within our academic community. Every student has the right
                    to pursue their education without worrying about being
                    harassed, intimidated, or subjected to humiliation, in our
                    opinion. Any kind of ragging is not allowed on PEWS’
                    property, and in order to protect our students, we have put
                    in place a thorough anti-ragging policy.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-5 ">
              <div className="anti-ragging">
                <div className="text-center pb-5">
                  <h3>Our Anti-Ragging Commitment</h3>
                </div>

                <div className="row">
                  <div className="col-md-3  d-flex justify-content-center ">
                    <div className="ragging-box box-1 px-3 pb-3">
                      <div className="text-center">
                        <div className="ragging-pin">
                          <img src="/assets/icons/pin.png" width={50} alt="pin icon" />
                        </div>
                      </div>
                      <div>
                        <h5>• Zero Tolerance: </h5>
                        <span className="text-justify">
                          Whether actively engaging in the act or aiding and
                          abetting it, any student found guilty of ragging will
                          be subject to severe disciplinary actions.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3  d-flex justify-content-center ">
                    <div className="ragging-box box-2 px-3 pb-3">
                      <div className="text-center">
                        <div className="ragging-pin">
                          <img src="/assets/icons/pin.png" width={50}  alt="pin for second"/>
                        </div>
                      </div>
                      <div>
                        <h5>• Awareness Programs: </h5>
                        <span className="text-justify">
                          To inform students about the negative impacts of
                          ragging and the related legal ramifications, we
                          regularly organize awareness programs and workshops.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3  d-flex justify-content-center ">
                    <div className="ragging-box box-3 px-3 pb-3">
                      <div className="text-center">
                        <div className="ragging-pin">
                          <img src="/assets/icons/pin.png" width={50} alt="pin for 3rd" />
                        </div>
                      </div>
                      <div>
                        <h5>• Counseling: </h5>
                        <span className="text-justify">
                          Whether actively engaging in the act or aiding and
                          abetting it, any student found guilty of ragging will
                          be subject to severe disciplinary actions.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3  d-flex justify-content-center ">
                    <div className="ragging-box box-4 px-3 pb-3">
                      <div className="text-center">
                        <div className="ragging-pin">
                          <img src="/assets/icons/pin.png" width={50} alt="pin ragging"/>
                        </div>
                      </div>
                      <div>
                        <h5>• Vigorous Supervision: </h5>
                        <span className="text-justify">
                          To stop any instances of ragging, a specialized team
                          keeps an eye on various parts of the campus.
                          Surveillance cameras have been installed to discourage
                          potential offenders.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row font-emoji">
              <div className="col-md-12">
                <Paper>
                  <div className="highlight-box">
                    <div className="">
                      <div className="row">
                        <div className="col-4 d-flex justify-content-end align-items-center calll">
                          <img
                            src="/assets/icons/phone.png"
                            className="highlight-animation"
                            alt="phone icon"
                            width={150}
                          />
                        </div>
                        <div className="col-8">
                          <div className="p-4">
                            <div className="">
                              <h3>Are You Being Ragged?</h3>
                            </div>

                            <div>
                              Call UGC Anti Ragging Helpline
                              <a href="callto:1800-180-5522">
                                {" "}
                                1800-180-5522{" "}
                              </a>{" "}
                              (24X7 toll free)
                              <br /> or send an email to: &nbsp;
                              <a href="mailto:helpline@antiragging.in">
                                helpline@antiragging.in!
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Paper>
              </div>

              <div className="row  justify-content-center aaa">
                <div className="bg-ragging"></div>

                <div className="m-2 p-2 text-center  ">
                  <h4>Indulging in acts of ragging can lead to</h4>
                </div>

                <div className="col-md-5">
                  <div className="m-2 p-2">
                    <div>
                      <li>Cancellation of Admission</li>
                      <li>Suspension from Attending Classes</li>
                      <li>
                        Withholding/Withdrawal of Scholarship/Fellowship and
                        Other Benefits
                      </li>
                      <li>
                        Debarment from appearing in any test/examination or
                        other evaluation processes.{" "}
                      </li>
                      <li>Withholding of Exam Results</li>
                    </div>
                  </div>
                  {/* <div className='ragg-bg'>AAA</div> */}
                </div>
                <div className="col-md-5">
                  <div className="m-2 p-2">
                    <div>
                      <li>
                        Debarment from representing the institution in any
                        regional, national or international meets.{" "}
                      </li>
                      <li>
                        If the person(s) abetting the crime is not identified, a
                        collective punishment will be handed out as a deterrent
                        to ensure community pressure on potential ragger!
                      </li>
                    </div>
                  </div>
                  {/* </Paper> */}
                </div>
              </div>
            </div>

            <hr />

            <div className="text-center p-4">
              <div className="">
                <strong>
                  As per instructions of the UGC, all the students are required
                  to fill the mandatory Anti-Ragging Affidavit
                </strong>
                &nbsp; &nbsp; &nbsp;
                <a
                  target="_blank"
                  href="https://antiragging.in/affidavit_registration_disclaimer.html"
                  className="btn btn-success"
                  rel="noopener noreferrer"
                >
                  Click Here
                </a>
              </div>
            </div>
            <hr />

            <div className="text-center p-4">
              <div className="">
                <strong>
                  Upload the Anti Ragging Undertaking Reference number and web
                  link that you received in your mail.
                </strong>
                &nbsp; &nbsp; &nbsp;
                <button onClick={handleClickOpen} className="btn btn-success">
                  Upload Here
                </button>
              </div>
            </div>
            <hr />
            <div className="text-center p-4">
              <div className="">
                <strong>
                  NATIONAL RAGGING PREVENTION PROJECT (COMPLIANCE)
                </strong>
                &nbsp; &nbsp; &nbsp;
                <a
                  target="_blank"
                  href="https://antiragging.in/compliance_desclaimer.html"
                  className="btn btn-success"
                  rel="noopener noreferrer"
                >
                  Click Here
                </a>
              </div>
            </div>
            <hr />
            <FormDialog
              form={<RaggingForm size={"md"} handleClose={handleClose} />}
              handleClickOpen={handleClickOpen}
              open={open}
              handleClose={handleClose}
            />

            <div className="p-4">
              <div className="text-center">
                <h4>INFORMATION ABOUT ANTIRAGGING AND IT'S REGULATIONS</h4>
              </div>

              <div className="m-4">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>SL No</TableCell>
                        <TableCell align="left">Deatils</TableCell>
                        <TableCell align="right">Download</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          1
                        </TableCell>
                        <TableCell align="left">
                          What Constitutes Ragging?
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/what_constitues_ragging.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          2
                        </TableCell>
                        <TableCell align="left">
                          Where can I get help?
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/where_can_I_get_help.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          3
                        </TableCell>
                        <TableCell align="left">
                          Why should I & How can I use online undertaking?
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/How_can_I_use_on_line_affidavits.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          4
                        </TableCell>
                        <TableCell align="left">
                          What is the Summary of UGC Regulations on Ragging?
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/SUMMARY_OF_UGC_REGULATIONS.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          5
                        </TableCell>
                        <TableCell align="left">
                          What is the Summary of the Order of the Hon. Supreme
                          Court on Ragging?
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/summary_of_the_Supreme_court_Judgment.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          6
                        </TableCell>
                        <TableCell align="left">
                          Notification about Notarising an Undertaking?
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/Notarising_an_Affidavit.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          7
                        </TableCell>
                        <TableCell align="left">
                          2nd Amendment published in gazette on 29.03.2014
                        </TableCell>
                        <TableCell align="right">
                          {" "}
                          <a
                            target="_blank"
                            href="https://new.cpmsc.com/backend/public/ragging/9541841_gazette_antiragging.pdf"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <PictureAsPdfIcon sx={{ fontSize: 40 }} />{" "}
                          </a>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>


            <div className="text-center p-4">
              <div className="">
                <strong>
                PEWS Anti Ragging Committee
                </strong>
                &nbsp; &nbsp; &nbsp;
                <a
                  target="_blank"
                  href="https://new.cpmsc.com/backend/public/assets/ragging/PurBanchal-Education-Welfare-Society.jpg"
                  rel="noopener noreferrer"
                  className="btn btn-success"
                >
                  View
                </a>
              </div>
            </div>
            <div>
              <div className="text-center m-3 p-3 py-5 mt-5">
                <i>
                  Together, let's establish a supportive, courteous, and secure
                  learning environment where each student can succeed without
                  worrying about being teased. By working together, we can
                  create a campus community that values empathy, respect, and
                  trust.
                </i>
              </div>
            </div>
          </Paper>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Ragging;
